import {useContext} from 'react'
import PropTypes from 'prop-types'
import {ExperimentContext} from './provider'

const Variation = ({experimentId, id, preRender, children}) => {
  const {
      variationMap,
      defaultVariationMap,
      staticBuild
    } = useContext(ExperimentContext),
    inVariation = variationMap[experimentId] !== undefined,
    assignedVariation = inVariation ? variationMap[experimentId] : defaultVariationMap[experimentId]

  if (assignedVariation === undefined) {
    throw `Experiment ${experimentId} is unknown`
  }

  if (staticBuild) {
    return preRender ? children : null
  } else {
    return assignedVariation === id ? children : null
  }
}

Variation.propTypes = {
  id: PropTypes.number.isRequired,
  experimentId: PropTypes.string.isRequired,
  preRender: PropTypes.bool
}

export default Variation
